import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyDcLc7Y4NisTQ7hE5RYFUu1XGTROcijOag",
  authDomain: "efficient-vineyard-crop-calc.firebaseapp.com",
  databaseURL: "https://efficient-vineyard-crop-calc.firebaseio.com",
  projectId: "efficient-vineyard-crop-calc",
  storageBucket: "efficient-vineyard-crop-calc.appspot.com",
  messagingSenderId: "430573833374"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')

export {
  db,
  auth,
  currentUser,
  usersCollection
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js